import Model from "@/app/models/Concerns/Model";

export default class Part extends Model {
    public isah_code!: string;
    public isah_group_code!: string;
    public description!: string;

    getTable(): string {
        return "parts";
    }
}